<script>
export default {
    name: "NHIFPatientReport",

    data() {

        return {
            patients: [],
            filter: {
                search: ``,
            }
        };
    },

    mounted() {

        this.$root.loading = true;
        Promise.allSettled([ this.fetchPatientWithDocuments(), ]).then(() => {
            this.$root.loading = false;
        }).catch(() => { this.$root.loading = false; });
    },

    methods: {

        fetchPatientWithDocuments() {

            return this.$http.get(`PatientRegistration/GetPatientsWithDocs`).then(response => {
                this.patients = response.data;
            }).catch(() => {});
        },

        fetchSearchedPatients() {
            this.$root.loading = true;
            if(!this.filter.search) {

                return this.fetchPatientWithDocuments().then(() => {
                    this.$root.loading = false;
                }).catch(() => { this.$root.loading = false; });
            }

            return this.$http.get(`PatientRegistration/GetPatientsWithDocsSearch?SearchText=${this.filter.search}`).then(response => {
                this.patients = response.data;
                this.$root.loading = false;
            }).catch(() => { this.$root.loading = false; });
        },
    },
}
</script>
<template>
<tail-base-layout>
  <template v-slot:breadcrum>
      <div class="bg-blue-800 p-tiny text-xs text-white rounded">
         <nav class="bg-grey-light rounded font-sans w-full p-tiny">
           <ol class="list-reset flex text-grey-dark">
             <li><router-link :to="{name : 'reports.patients'}">Patient Reports</router-link></li>
             <li><span class="mx-2">/</span></li>
             <li>Patients With Documents Report</li>
           </ol>
         </nav>
      </div>
  </template>
  <template v-slot:content>
      <tail-card>
        <template v-slot:card-header>
            <h5 class="font-bold text-sm">Patients With Documents Report</h5>
        </template>
        <template v-slot:card-body>
          <div class="flex flex-wrap">
              <div class="md:w-1/5 sm:w-1/2 p-tiny">
                  <label for="grid-search" class="label-control">Search:</label>
                  <input type="text" v-model.trim="filter.search" @keydown.enter="fetchSearchedPatients" id="grid-search" class="input-control input-sm text-xs">
              </div>
              <div class="md:w-1/12 sm:w-1/4 p-tiny mt-3">
                  <button class="btn-sm btn-info text-xs rounded" @click.prevent="fetchSearchedPatients"><i class="fa fa-filter"></i> Filter</button>
              </div>
              <div class="md:w-1/12 sm:w-full p-tiny mt-3">
                  <button class="btn-sm btn-primary text-xs rounded" @click.prevent="$root.exportToExcel(`patient-documents-report`, `patientDocumentReport`)"><i class="fa fa-file-excel"></i> Export</button>
              </div>
          </div>
          <div class="w-full overflow-auto">
              <table class="table table-hover" id="patientDocumentReport">
                  <thead class="bg-blue-500 text-xs text-white">
                        <tr class="w-full flex">
                            <th class="p-tiny w-1/12">MRN</th>
                            <th class="p-tiny w-1/6">NAMES</th>
                            <th class="p-tiny w-1/12">DOB</th>
                            <th class="p-tiny w-1/6">CELLPHONE</th>
                            <th class="p-tiny w-1/6">IPFILENO</th>
                            <th class="p-tiny w-1/6">OPFILENO</th>
                            <th class="p-tiny w-1/12">VISIT(S)</th>
                            <th class="p-tiny w-1/12">ACTION</th>
                        </tr>
                  </thead>
                  <tbody class="text-xs bg-gray-100 flex flex-col items-center overflow-auto" style="height:65vh;">
                      <tr class="flex w-full" v-for="(patient, idx) in patients" :key="idx">
                          <td class="p-tiny w-1/12">{{ patient.patienT_ID }}</td>
                          <td class="p-tiny w-1/6">{{ patient.names }}</td>
                          <td class="p-tiny w-1/12">{{ patient.dob }}</td>
                          <td class="p-tiny w-1/6">{{ patient.celL_PHONE || `-` }}</td>
                          <td class="p-tiny w-1/6">{{ patient.ipfileno }}</td>
                          <td class="p-tiny w-1/6">{{ patient.opfileno }}</td>
                          <td class="p-tiny w-1/12">{{ patient.visitcount }}</td>
                          <td class="p-tiny w-1/12">
                            <button class="btn-sm btn-info text-xs rounded"><i class="fa fa-file"></i> Documents</button>
                          </td>
                      </tr>
                  </tbody>
              </table>
          </div>
        </template>
      </tail-card>
  </template>
</tail-base-layout>
</template>